<!-- Avertissement global de calcul du calepinage : bandeau fixe centré en bas de l'écran. -->
<div class="calepinage-calculating-toast" *ngIf="(calculating$ | async)">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span>Calcul du calepinage en cours…</span>
</div>

<div class="recap-bubble" *ngIf="(stats$ | async) as stats" [hidden]="stats.nbPanneaux === 0">
    <div class="recap-title">Zone {{ stats.numeroZone }}</div>

    <div class="recap-line"
         ngbTooltip="Nombre total de panneaux placés par le calepinage automatique sur cette zone."
         placement="right">
        <span class="label">Panneaux <i class="bi bi-info-circle"></i></span>
        <span class="value">{{ stats.nbPanneaux }}</span>
    </div>

    <div class="recap-line"
         ngbTooltip="Emprise au sol (projection horizontale vue du ciel). Calcul géodésique sur les polygones des panneaux. Cohérent avec la surface affichée dans le formulaire de zone — utile pour comparer la couverture par rapport à l'emprise totale de la zone."
         placement="right">
        <span class="label">Surface au sol <i class="bi bi-info-circle"></i></span>
        <span class="value">{{ stats.surfaceAuSolM2 | number:'1.0-1' }} m²</span>
    </div>

    <div class="recap-line"
         ngbTooltip="Surface réelle des modules photovoltaïques (nb × largeur × longueur du panneau). Sert au dimensionnement énergétique. Diffère de la surface au sol selon l'inclinaison du système : très proche pour systèmes peu inclinés (LESTE, OMBRIERE ~10°), plus écartée pour BAC ACIER en pente forte."
         placement="right">
        <span class="label">Surface PV <i class="bi bi-info-circle"></i></span>
        <span class="value">{{ stats.surfacePvM2 | number:'1.0-1' }} m²</span>
    </div>

    <div class="recap-line"
         ngbTooltip="Puissance crête estimée (nb panneaux × puissance unitaire / 1000), selon la gamme panneau sélectionnée (CRE/FR). Indicative — la puissance définitive est calculée par le back."
         placement="right">
        <span class="label">Puissance <i class="bi bi-info-circle"></i></span>
        <span class="value">{{ stats.puissanceKwc | number:'1.0-2' }} kWc</span>
    </div>
</div>
